import $http from "../axios";

const state = {
  invoicesPacks: [],
  invoicesPackQty: 0
};

const getters = {};

const actions = {
  getInvoice(_, data) {
    return new Promise((resolve, reject) => {
      $http
        .get(
          // eslint-disable-next-line prettier/prettier
          `get-invoice`,
          { params: { ...data } }
        )
        .then(res => {
          resolve(res);
        })
        .catch(e => {
          reject(e);
        });
    });
  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};
